import { useState, useEffect } from "react";
import { mapRoles } from "../../../../utils/roles";
import useClickOutside from "../../../../CustomHooks/useClickOutside";
import { Search } from "lucide-react";
import { Controller } from "react-hook-form";

const MultipleChecks = ({name, options, error, roles, control }) => {
  const mappedRoles = options.map((role) => ({
    key: role,
    label: mapRoles[role] || role,
  }));
  const [searchList, setSearchList] = useState(mappedRoles);
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));

  const isRole = roles?.length > 0;

  const handleShowDropdown = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filter = mappedRoles.filter((item) =>
      item.label.toLowerCase().includes(value),
    );

    setSearchList(filter);
  };

  useEffect(() => {
    setSearchList(mappedRoles);
  }, [options]);

  return (
    <>
      <label htmlFor="role" className="checkBoxDropdownLabel">
        Role *
      </label>
      <div className="relative" ref={dropdownRef}>
        <p
          onClick={() => handleShowDropdown()}
          className={`checkBoxDropdownLabelWrap ${
            error ? "border-red-500" : "border-lg4"
          }`}
        >
          {isRole ? `Role (${roles.length})` : "Select"}
          <span
            className={`checksDropdownArr ${
              open === 1 ? "rotate-90" : "rotate-90n"
            }`}
          >{`<`}</span>
        </p>
        <div
          className={`checksOptionWrap ${
            open === 1 ? "grid opacity-1" : "invisible opacity-0"
          }`}
        >
          <p className="mb-2">
            <input
              type="text"
              placeholder="Search"
              onChange={handleSearch}
              className="cy-search-inp"
            />
            <Search size={16} className="absolute right-4 top-4" />
          </p>
          <Controller
            name={name}
            control={control}
            rules={{ required: "Please select at least one role." }}
            render={({ field }) => {
              const { value = [], onChange } = field;
              const handleCheckbox = (role) => {
                if (value.includes(role)) {
                  onChange(value.filter((r) => r !== role));
                } else {
                  onChange([...value, role]);
                }
              };

              return (
                <>
                  {searchList.length > 0 ? (
                    <ul className="h-40 overflow-y-scroll">
                      {searchList.map((item) => (
                        <li key={item.key} className="checksItems">
                          <input
                            type="checkbox"
                            id={item.key}
                            checked={value.includes(item.key)}
                            onChange={() => handleCheckbox(item.key)}
                            className="accent-input"
                          />
                          <label htmlFor={item.key} className="checksLabel">
                            {item.label}
                          </label>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="py-1 px-2 text-sm text-red-400">Not Found</p>
                  )}
                </>
              );
            }}
          />
        </div>
        <p className={`input-err ${error ? "visible" : "invisible"}`}>
          {error?.message}
        </p>
      </div>
    </>
  );
};
export default MultipleChecks;
